var generic = generic || {};
var site = site || {};

(function ($) {
  site.waitlist = {
    templateContainer: $(),

    initWaitlistSignup: function () {
      var $emailContainerNodes = this.templateContainer;

      if (!$emailContainerNodes.length) {
        return null;
      }

      $emailContainerNodes.each(function () {
        var waitlistContainerNode = $(this);

        /* Close Button */
        waitlistContainerNode.find('.close-button').unbind('click').bind('click', function () {
          waitlistContainerNode.slideUp(600);

          return false;
        });
        /* Close Button */
        /* Show hide additional units */
        // grab class name from hidden unit
        var classShowHide = document.getElementById('unit_class_reveal').value;

        // hide the unit to begin with, if it exists
        if (classShowHide.length > 0) {
          $('.' + classShowHide).hide();
        }
        // $('.' + classShowHide).css({"position":"fixed","left":"-9999999"});
        /* Submit Form */
        var waitlistFormNode = waitlistContainerNode.find('form'),
          waitlistSubmitNode = waitlistContainerNode.find("input[type='submit']"),
          waitlistProgressNode = waitlistContainerNode.find('div.progress'),
          waitlistSuccessNode = waitlistContainerNode.find('div.success'),
          waitlistErrorNode = waitlistContainerNode.find('div.error'),
          waitlistInputNode = waitlistContainerNode.find('input.waitlist_signup'),
          waitlistSubmissionOption = waitlistContainerNode.find("input[name='redirect_or_text']"),
          waitlistRedirectURL = waitlistContainerNode.find("input[name='redirect']"),
          waitlistSignupText = waitlistContainerNode.find('div.waitlist_signup_text'),
          waitlistSignupFields = waitlistContainerNode.find('div.waitlist_signup_fields'),
          emailOptStatusNode = $('#address-info-newsletter');

        waitlistFormNode.not('.email-form-processed').addClass('email-form-processed').unbind('submit').bind('submit', function (submitEvt) {
          submitEvt.preventDefault();
          waitlistSubmitNode.addClass('hidden');
          waitlistProgressNode.removeClass('hidden');

          // retrieve form data in querystring format
          var formSerial = waitlistFormNode.serialize();
          // transform string into array of form elements
          var paramArr = formSerial.split('&'),
            paramStr = '';

          // iterate through collection to transform form name/value into key/value properties of a literal object string.
          $.each(paramArr, function (index) {
            paramStr += '"' + this.split('=')[0] + '":"' + this.split('=')[1] + '",';
          });

          // parse the string and create the literal object
          var params = eval('(' + '{' + paramStr.substring(0, paramStr.length - 1).replace('undefined', '').replace('%40', '@') + '}' + ')');

          // remove the 2 hidden inputs we're using to handle the redirect
          params.redirect = undefined;
          params.redirect_or_text = undefined;

          // send the data via a json rpc call
          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: [params],
            onSuccess: function (jsonRpcResponse) {
              if (waitlistSubmissionOption.val() === 'redirect' && waitlistRedirectURL.val().length > 0) {
                // Redirect the current page to another
                var dest = waitlistRedirectURL.val();

                if (/^\/.+$/.test(dest)) {
                  dest = dest.replace(/^(\s|\/)+/, '');
                }
                if (/^(?!http|\/).+$/.test(dest)) {
                  dest = Drupal.settings.basePath + dest;
                }
                window.location.href = dest;

                return false;
              } else {
                // Show success messages within this template
                waitlistProgressNode.addClass('hidden');
                waitlistSuccessNode.removeClass('hidden');
                waitlistErrorNode.addClass('hidden');
                waitlistFormNode.addClass('hidden');
                emailOptStatusNode.addClass('hidden');
                waitlistSignupText.addClass('hidden');
                waitlistSignupFields.addClass('hidden');
                waitlistContainerNode.addClass('email_success');
                $('html,body').animate({
                  scrollTop: $('.success').offset().top - 130
                }, 1000);
                // check to see if we have a class name
                if (classShowHide.length > 0) {
                  $('.' + classShowHide).css('visibility', 'hidden');
                  $('.' + classShowHide).show();
                  // This is required as hidden slider blocks compute on document ready with width 0
                  // so we need to refresh the block to display properly and we dont want the user watching all this
                  // so we hide it whilst it is all happening
                  $('.slick-slider').slick('setOption', 'refresh', true, true);
                  $('.' + classShowHide).css('visibility', 'visible');
                }
                // tagging
                $(document).trigger('waitlist:success', [waitlistContainerNode.find("input[name='EVENT_ID']")]);
              }
            },
            onFailure: function (jsonRpcResponse) {
              // Add the error messages below the header
              var errorObjectsArray = jsonRpcResponse.getMessages();
              // generic.showErrors(errorObjectsArray);

              // Show error messages in this template
              waitlistErrorNode.html(errorObjectsArray[0].text).removeClass('hidden');
              waitlistProgressNode.addClass('hidden');
              // just in case
              if (classShowHide.length > 0) {
                $('.' + classShowHide).hide();
              }
              waitlistSubmitNode.removeClass('hidden');
              waitlistInputNode.addClass('error');
              waitlistContainerNode.removeClass('email_success');
              // tagging
              $(document).trigger('waitlist:failure', [waitlistContainerNode.find("input[name='EVENT_ID']")]);
            }
          });
        });
        /* Submit Form */
      });
    }
  };

  Drupal.behaviors.waitlistSignup = {
    attach: function (context) {
      site.waitlist.templateContainer = $('.waitlist-signup-container', context);
      site.waitlist.initWaitlistSignup();
    }
  };

  Drupal.behaviors.selectBox = {
    toggleOptions: function ($newSelect) {
      if (!$newSelect.hasClass('js-select-box-disabled')) {
        $newSelect.children('.js-select-box-options').toggleClass('open');
        $newSelect.children('.js-select-box-label').toggleClass('open');
      }
    },
    setLabel: function ($oldSelect) {
      var selectedText = $oldSelect.children('option:selected').text() || $oldSelect.children('option').first().text();
      var $newSelect = $oldSelect.data('new-select-box-reference');

      if (!!$newSelect) {
        $newSelect.children('.js-select-box-label').text(selectedText);
      }
    }
  };
})(jQuery);

function populateSelect(target, min, max) {
  if (!target) {
    return false;
  } else {
    min = min || 0;
    max = max || min + 100;

    var select = document.getElementById(target);

    for (var i = min; i <= max; i++) {
      var opt = document.createElement('option');

      opt.value = i;
      opt.innerHTML = i;
      select.appendChild(opt);
    }
  }
}

$(document).ready(function () {
  populateSelect('form--profile_preferences--field--BIRTH_DAY', 1, 31);
  populateSelect('form--profile_preferences--field--BIRTH_MONTH', 1, 12);
  populateSelect('form--profile_preferences--field--BIRTH_YEAR', 1901, 2010);
  $('#terms_trigger').click(function () {
    $('#terms_details').toggle();
    $('#terms_arrow_1').toggle();
    $('#terms_arrow_2').toggle();
  });
  $('#terms_anchor_trigger').click(function () {
    $('#terms_details').toggle();
    $('#terms_arrow_1').toggle();
    $('#terms_arrow_2').toggle();
  });
});
